module.exports = __webpack_public_path__ + "static/AmnestyTradeGothic-Bd2-be096aa636ecd7d612c412eb6cf54b5a.ttf";